/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const STORE = 'STORE'
export const UPDATE = 'UPDATE'
export const CHECK = 'CHECK'
export const LOAD = 'LOAD'
export const UNLOAD = 'UNLOAD'
export const SET_AGREE_POLICY = 'SET_AGREE_POLICY'

export default {
  STORE,
  UPDATE,
  CHECK,
  LOAD,
  UNLOAD,
  SET_AGREE_POLICY
}
